import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Импортируем переводы как ES модули
import enCommon from './locales/en/common.json';
import enValidation from './locales/en/validation.json';
import enPlaceholders from './locales/en/placeholders.json';
import enNotifications from './locales/en/notifications.json';
import enErrors from './locales/en/errors.json';
import enHelp from './locales/en/help.json';

// Отладочная информация
console.log('i18n imports - enCommon:', enCommon);
console.log('i18n imports - enCommon keys:', Object.keys(enCommon));
console.log('i18n imports - print_run_form exists:', 'print_run_form' in enCommon);

import ruCommon from './locales/ru/common.json';
import ruValidation from './locales/ru/validation.json';
import ruPlaceholders from './locales/ru/placeholders.json';
import ruNotifications from './locales/ru/notifications.json';
import ruErrors from './locales/ru/errors.json';
import ruHelp from './locales/ru/help.json';

import srCommon from './locales/sr/common.json';
import srValidation from './locales/sr/validation.json';
import srPlaceholders from './locales/sr/placeholders.json';
import srNotifications from './locales/sr/notifications.json';
import srErrors from './locales/sr/errors.json';
import srHelp from './locales/sr/help.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false, // React уже экранирует
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    
    ns: ['common', 'validation', 'notifications', 'errors', 'placeholders', 'help'],
    defaultNS: 'common',
    
    resources: {
      en: {
        common: enCommon,
        validation: enValidation,
        notifications: enNotifications,
        errors: enErrors,
        placeholders: enPlaceholders,
        help: enHelp,
      },
      ru: {
        common: ruCommon,
        validation: ruValidation,
        notifications: ruNotifications,
        errors: ruErrors,
        placeholders: ruPlaceholders,
        help: ruHelp,
      },
      sr: {
        common: srCommon,
        validation: srValidation,
        notifications: srNotifications,
        errors: srErrors,
        placeholders: srPlaceholders,
        help: srHelp,
      },
    },
  });

export default i18n;
